import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createBuddyTalktimePlan,
  getAIChatHistory,
  getAllBuddyTalktimePlans,
  updateBuddyTalktimePlan,
} from '../AkademySlice';
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import CustomForm from '../../../components/FormRenderer/CustomForm';

import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';

import { secondsToString } from '../../../utils/helpers';
import { currencyOptions } from '../../../utils/constants';
import moment from 'moment';
import StatsBox from './StatsBox';

function AIAssistConsumption() {
  const dispatch = useDispatch();
  const { handleLoader } = useLoader();
  const { SuccessToast, ErrorToast } = useToast();

  const { aiChatHistory, loading } = useSelector(({ akademyReducer }) => {
    return {
      aiChatHistory: akademyReducer.aiChatHistory,
      loading: akademyReducer.loading,
    };
  });

  useEffect(() => {
    dispatch(getAIChatHistory({ origin: 'AI_ASSIST' }));
  }, []);

  const talktimeConsumptionColumns = [
    {
      Header: 'Date',
      accessor: 'createdAt',
      Cell: (val) => {
        const { createdAt } = val.cell.row.original;

        return (
          <Typography>{moment(createdAt).format('DD MMM YYYY')}</Typography>
        );
      },
    },
    {
      Header: 'User',
      accessor: 'user.name',
      Cell: (val) => {
        const { user } = val.cell.row.original;

        return (
          <Typography>
            {user && user.name} | {user && user.email}
          </Typography>
        );
      },
    },
    {
      Header: 'AI Tokens',
      accessor: '',
      Cell: (val) => {
        const { chats } = val.cell.row.original;

        let aiTokens = chats.reduce((prevVal, { metadata }) => {
          return prevVal + (metadata.AItokens || 0);
        }, 0);

        return <Typography>{aiTokens}</Typography>;
      },
    },
  ];

  return (
    <Box>
      <StatsBox
        aiChatHistory={aiChatHistory}
        date={new Date()}
        disableTalktime={true}
      />
      <StatsBox
        aiChatHistory={aiChatHistory}
        date={moment(new Date()).subtract(1, 'months')}
        disableTalktime={true}
      />
      <Box my={2}>
        {loading ? (
          <CircularProgress />
        ) : (
          <BuzzTable
            columns={talktimeConsumptionColumns}
            data={aiChatHistory}
            isHandlePagination={true}
          />
        )}
      </Box>
    </Box>
  );
}

export default AIAssistConsumption;
